












































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { MotivoExclusaoItemRepasseEnum } from '@/types/_'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentModalItensDoRepasse extends Vue {
  $refs!: { formMotivoExclusao: any }
  loadExcluirItem: boolean = false

  get modalConfirmarExclusao() { return this.getFinanceiroStore.modal.excluirItemRepasse }
  set modalConfirmarExclusao(value: boolean) { this.getFinanceiroStore.setModal({ name: 'excluirItemRepasse', value }) }

  get loadingExcluirItem() { return this.loadExcluirItem }
  set loadingExcluirItem(value: boolean) { this.loadExcluirItem = value }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  formMotivoExclusao: any = {
    valid: true,
    motivoExclusao: [(v: string) => !!v || 'Campo obrigatório.'],
    observacaoMotivoExclusao: [(v: string) => this.validateMotivo(v)],
  }

  validateMotivo(value: string) {
    if (this.getFinanceiroStore.motivoExclusaoItemRepasse.motivoExclusao === MotivoExclusaoItemRepasseEnum.Outro && value === '') return 'Por favor, forneça uma justificativa para a exclusão'
    return true
  }

  motivosExclusaoItemRepasse: any[] = [
    { value: MotivoExclusaoItemRepasseEnum.ExcluidoSistemaHospitalar, text: 'Excluído do sistema hospitalar' },
    { value: MotivoExclusaoItemRepasseEnum.LancamentoIndevido, text: 'Lançamento indevido' },
    { value: MotivoExclusaoItemRepasseEnum.CalculoIncorreto, text: 'Cálculo incorreto' },
    { value: MotivoExclusaoItemRepasseEnum.Outro, text: 'Outro' },
  ]

  async excluirItem() {
    this.loadingExcluirItem = true
    if (this.$refs.formMotivoExclusao.validate()) {
      const response = await this.getFinanceiroStore.excluirItemRepasse()
      if (!response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao tentar apagar o registro.', icon: 'warning', color: '#C62828' })
        this.loadingExcluirItem = false
        return
      }
      EventBus.$emit('setSnackbar', { show: true, text: 'Item excluído com sucesso!', icon: 'done', color: '#2E7D32' })
      this.getFinanceiroStore.deleteItemsFromGeracaoDeRepassesItemsPrestador(this.getFinanceiroStore.motivoExclusaoItemRepasse.ids)

      const id = this.getFinanceiroStore.idForLoadItensRepasse
      await this.getFinanceiroStore.getGeracaoDeRepasseItensPrestador(id)
      this.modalConfirmarExclusao = false
    }
    this.loadingExcluirItem = false
  }

  @Watch('modalConfirmarExclusao')
  onChangeModalConfirmarExclusao(value) {
    if (!value) {
      this.$refs.formMotivoExclusao.resetValidation()
      this.$refs.formMotivoExclusao.reset()
      this.getFinanceiroStore.clearMotivoExclusaoItemRepasse()
    }
  }
}
